import { getSrcs } from '@helpers/image';
import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { withMotion } from '@hoc/withMotion';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../Header.styles';
import IllustratedCard from '@stories/Components/Cards/IllustratedCard/IllustratedCard';
const DesktopNavigation = (props) => {
    const [activeId, setActiveId] = React.useState('');
    if (!props.links) {
        return null;
    }
    const handleActivateChange = (id) => {
        if (id) {
            if (activeId === id) {
                setActiveId('');
            }
            else {
                setActiveId(id);
            }
        }
        else {
            setActiveId('');
        }
    };
    return (React.createElement(S.DesktopNav, null,
        React.createElement(S.DesktopNavInner, null, props.links.map((link) => (React.createElement(NavLink, { key: link.id, activeId: activeId, onActivateChange: handleActivateChange, ...link }))))));
};
const NavLink = (props) => {
    const dropDownRef = React.useRef(null);
    const srcs = props.featuredImage?.src && getSrcs(props.featuredImage, 544, 344, 2, 2 / 1);
    const hasDropdown = (props.sectionLinks && props.sectionLinks.length > 0) ||
        (props.illustratedCards && props.illustratedCards.length > 0);
    return (React.createElement(S.DesktopNavItem, { tabIndex: props.activeId !== props.id ? -1 : undefined, "data-is-active": props.activeId === props.id, onClick: (e) => {
            e.target !== this ? props.onActivateChange(props.id) : false;
        } },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" }, hasDropdown ? (React.createElement(S.DesktopPrimaryNavButton, null,
            props.page.text,
            getSvgFromSystem(SystemIcon.ChevronDown))) : (React.createElement(S.DesktopPrimaryNavLink, { href: props.page.url, target: props.page.target }, props.page.text))),
        hasDropdown && (React.createElement(S.DropdownMenu, null,
            React.createElement(S.DropdownMenuWrapper, null,
                React.createElement(S.DropdownMenuInner, { ref: dropDownRef },
                    React.createElement(S.DropdownMenuInnerTop, null,
                        React.createElement(S.DropdownMenuTitle, null, props.page.text),
                        React.createElement(S.DropdownMenuClose, { onClick: (e) => {
                                props.onActivateChange();
                                e.stopPropagation();
                            }, "aria-label": props.translations && props.translations['translations.global.menu.close'], title: props.translations && props.translations['translations.global.menu.close'] }, getSvgFromSystem(SystemIcon.Close))),
                    props.sectionLinks && props.sectionLinks.length > 0 && (React.createElement(S.DropdownMenuInnerBottom, null,
                        React.createElement(S.DropdownMenuInnerBottomContent, null,
                            props.summary && (React.createElement(S.DropdownMenuSummary, { dangerouslySetInnerHTML: { __html: props.summary } })),
                            props.sectionLinks && (React.createElement(S.DropdownMenuNav, null, props.sectionLinks.map((link, index) => (React.createElement("li", { key: `dropdown-nav-link-${index}` },
                                React.createElement(S.DropdownMenuNavLink, { href: link.url, target: link.target ?? '_self' },
                                    getSvgFromSystem(SystemIcon.ChevronRight),
                                    React.createElement(S.DropdownMenuNavLinkText, null, link.text)))))))),
                        props.featuredImage && (React.createElement(S.DropdownMenuImageWrapper, null, srcs && (React.createElement(S.DropdownMenuImage, { src: srcs.src, srcSet: srcs.srcSet, alt: props.featuredImage.altText, loading: "lazy" })))))),
                    props.illustratedCards && props.illustratedCards.length > 0 && (React.createElement(S.CardsList, null, props.illustratedCards.map((item, index) => (React.createElement(IllustratedCard, { key: `illustrated-card-${index}`, ...item }))))))),
            React.createElement(S.DropdownMenuBackdrop, { onClick: (e) => {
                    props.onActivateChange();
                    e.stopPropagation();
                } })))));
};
export default withMotion(DesktopNavigation);
